import { ChangeDetectionStrategy, Component, inject, OnInit, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HorizontalScrollComponent, TitleSummaryComponent } from '@client-monorepo/common/ui-components';
import { rangeCreator } from '@client-monorepo/common/utilities';
import { StoreService } from '../../data-access/services/store.service';
import { NgxChipComponent } from '@digipay/ngx-chip';

@Component({
  selector: 'stores-applet-suggested-searches',
  standalone: true,
  imports: [CommonModule, TitleSummaryComponent, HorizontalScrollComponent, NgxChipComponent],
  templateUrl: './suggested-searches.component.html',
  styleUrl: './suggested-searches.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestedSearchesComponent implements OnInit {
  storeService = inject(StoreService);
  suggestionsLoading = signal<boolean>(true);
  searchSuggestions = signal<Array<string>>([]);
  itemClicked = output<string>();

  rangeCreator = rangeCreator;

  ngOnInit() {
    this.getSuggestedSearches();
  }

  getSuggestedSearches(): void {
    this.suggestionsLoading.set(true);
    this.storeService.getSugestedSearches().subscribe({
      next: (result) => {
        this.searchSuggestions.set(result);
        this.suggestionsLoading.set(false);
      },
    });
  }

  itemClickedHandle(itemText: string): void {
    this.itemClicked.emit(itemText);
  }
}
